<template>
    <div class="zuke_index">
        <div class="city">
            <div class="head_box">
                <div class="head_top_box">
                    <div class="head_top">
                        <a @click="city_show()" href="javascript:;"><img src="../../assets/images/left.png" alt=""></a>
                        <h1>城市选择</h1>
                        <div class="head_top_btn"></div>
                    </div>
                </div>
            </div>
            <div class="city_box" v-for="(city,key,index) in city_arr">
                <div class="city_list">{{key}}</div>
                <div class="city_list" v-for="list in city_arr[key]" @click="city_btn(list.code,list.name)">{{list.name}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "city",
        data:()=>{
            return {
                city_arr:[]
            }
        },
        methods:{
            // 城市选择
            city_btn(num,name){
                var data = {num:num,name:name}
                this.$emit('func',data)
            },
            city_show(){
                this.$parent.city_show = 0
            }
        },
        mounted() {
            var _this = this
            var getinfoData = _this.$publicObj.getSign('/place/city', {
                type: "open"
            },_this.$store.state);
            $.ajax({
                url: 'https://japiv2.zuke.com/place/city',
                type: 'post',
                data: getinfoData,
                success: function(res) {
                    if(res.code == 10000){
                        _this.city_arr = res.data
                        // console.log(res.data)
                    }
                }
            })
        },
    }
</script>

<style scoped>
    .city {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 200;
        background-color: #fff;
        overflow-y: scroll;
    }
    
    .head_box {
        height: 1.877333rem;
    }
    
    .head_top_box {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 1.877333rem;
        border-bottom: 1px solid #ddd;
    }
    
    .head_top {
        display: flex;
        width: 100%;
        min-width: 8rem;
        max-width: 16rem;
        margin: 0 auto;
        height: 1.877333rem;
        background-color: #fff;
    }
    
    .head_top a {
        display: block;
        width: 2.56rem;
        height: 1.877333rem;
    }
    
    .head_top a img {
        display: block;
        height: 1.28rem;
        margin: 0 auto;
        padding: 0.298666rem;
    }
    
    .head_top h1 {
        flex: 1;
        text-align: center;
        height: 1.877333rem;
        line-height: 1.877333rem;
        font-size: 0.768rem;
        color: #333;
        font-weight: 500;
    }
    
    .head_top .head_top_btn {
        display: block;
        width: 2.56rem;
        height: 1.877333rem;
    }
    
    .city_list {
        height: 2rem;
        line-height: 2rem;
        font-size: 0.65rem;
        padding-left: 0.5rem;
        border-bottom: 0.02rem solid #eeeeee;
    }
</style>


// WEBPACK FOOTER //
// city.vue